
<template lang="pug">
QSelectMod.select-time(
  v-bind="$attrs"
  :value="value"
  :options="options"
  popup-max-height="216px"
  v-on="$listeners"
)
</template>

<script>
import {addSeconds} from 'date-fns/esm'

import {timeToObject, timeToString, timeFilter, isEqualOrBefore} from 'helpers/date'
import {mapAuto} from 'helpers/vuex-bind'

import QSelectMod from 'components/QSelectMod'

export default {
  components: {QSelectMod},

  props: {
    value: {required: true},
    min: String,
    max: String,
  },

  computed: {
    ...mapAuto(['timeStepMinutes']),

    options() {
      const options = []
      let time = timeToObject(this.min || '0000')
      const end = timeToObject(this.max || '2700')
      while(isEqualOrBefore(time, end)) {
        const value = timeToString(time)
        options.push({
          label: timeFilter(time, 'mm:ss'),
          value,
          rightIcon: value === this.value ? 'done' : null,
        })
        time = addSeconds(time, this.timeStepMinutes)
      }
      return options
    },
  },
}
</script>

<style lang="sass">
.select-time
  width: 7rem
</style>
